var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.8,
    height: 15.628,
    viewBox: "0 0 14.8 15.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(-1744.6 -3568.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68748",
    "data-name": "Path 68748",
    d: "M18,24.8l6.4-6.4L18,12",
    transform: "translate(1734 3557.6)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68749",
    "data-name": "Path 68749",
    d: "M12,18H24.8",
    transform: "translate(1733.6 3558)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrowNext);
export default __webpack_public_path__ + "static/media/slider_arrow_next.ce3e4b09f59360d3caa6ae1cbdd54d04.svg";
export { ForwardRef as ReactComponent };